/* eslint-disable react/display-name */
import React, { memo } from 'react';
import styled from 'styled-components';

import { translate } from '../../../common/translation/translate';
import { ErrorBoundaryIcon } from '../../common/errorBoundary/errorBoundaryIcon';

export const OutdoorSportsLoadingErrorUI = memo(() => {
    return (
        <Container>
            <TitleWrapper>
                <IconWrapper>
                    <ErrorBoundaryIcon />
                </IconWrapper>
                <NoDataText isTitle={true}>{translate('failedToLoad')}</NoDataText>
            </TitleWrapper>
            <NoDataText isTitle={false}>{translate('dataLoadErrorMessage')}</NoDataText>
        </Container>
    );
});

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding: 12px 10px;
`;

export const TitleWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 32px;
`;

export const IconWrapper = styled.span`
    display: flex;
    flex-direction: column;
    background: #F9F9F9;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 100%;
`;

interface NoDataTextProps {
    isTitle: boolean;
}
export const NoDataText = styled.div<NoDataTextProps>`
    display: flex;
    flex-direction: row;
    align-items: center;
    font-family: Source Sans Pro;
    font-style: normal;
    font-size: 16px;
    line-height: 20px;
    color: #333333;
    font-weight: ${({ isTitle }) => isTitle ? '600' : 'normal' };
    margin-left: ${({ isTitle }) => isTitle ? '10px' : '42px' };
`;
